import dynamic from "next/dynamic";
const App = dynamic(() => import("../../components/App"));
import Head from "next/head";
import { useRouter } from "next/router";
import { Breadcrumb, Image, Row, Col } from "antd";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Link from "next/link";

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

const ComponentTh = () => {
  return (
    <div className="container" style={{ marginTop: 24 }}>
      <h3 id="cookie-policy" style={{ marginBlock: 24 }}>
        <a aria-hidden="true" href="#cookie-policy" tabindex="-1">
          <span className="icon icon-link"></span>
        </a>
        การชำระเงิน
      </h3>
      <p>
        วิธีการชำระเงินของ Luxury29 มีหลากหลายช่องทางด้วยกัน สะดวก รวดเร็ว
        ปลอดภัย ทั้ง บัตรเครดิต และพร้อมเพย์
      </p>

      <h4>ชำระผ่านบัตรเครดิต</h4>
      <p>
        คุณสามารถเลือกชำระค่าสินค้าและบริการด้วยบัตรเครดิตที่มีตราสัญลักษณ์
        [VISA], [Mastercard] และ [JCB] ทั่วประเทศ และทั่วโลก
        และสั่งซื้อสินค้าได้ง่ายๆ ผ่านทางหน้าเว็บไซต์
      </p>
      <Image
        style={{ marginBottom: 48 }}
        src="/static/images/howto/creditcard.png"
        preview={false}
        alt="howto"
      />

      {/* <h4>ชำระโดยการโอนผ่านพร้อมเพย์</h4>
      <p>คุณสามารถเลือกชำระค่าสินค้าและบริการโดยการโอนเงินผ่านผ่านพร้อมเพย์</p>
      <Image
        style={{ marginBottom: 48 }}
        src="/static/images/howto/payment-promptpay.png"
        preview={false}
        alt="howto"
      /> */}
    </div>
  );
};

const ComponentEn = () => {
  return (
    <div className="container" style={{ marginTop: 24 }}>
      <h3 id="cookie-policy" style={{ marginBlock: 24 }}>
        <a aria-hidden="true" href="#cookie-policy" tabindex="-1">
          <span className="icon icon-link"></span>
        </a>
        Payment
      </h3>
      <p>
        There are many payment methods to pay at Luxury29 though variety of
        channels such as credit cards and PromptPay, which is convenient, fast,
        safe
      </p>

      <h4>Credit card </h4>
      <p>
        You can choose to pay for goods and services with credit cards bearing
        the [VISA], [Mastercard] and [JCB] logos nationwide and worldwide, and
        make purchases easily. through the website
      </p>
      <Image
        style={{ marginBottom: 48 }}
        src="/static/images/howto/creditcard.png"
        preview={false}
        alt="howto"
      />
    </div>
  );
};

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const router = useRouter();
  const { locale } = router;
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const { t } = useTranslation("common");

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>Payment</title>
      </Head>
      <Row justify="center" style={{ marginBlock: 24 }}>
        <Col xs={22} sm={22} md={22} lg={22} xl={20}>
          <Breadcrumb
            items={[
              {
                key: "home",
                title: (
                  <Link href={`/${queryParam ? `?${queryParam}` : ``}`}>
                    {t("home")}
                  </Link>
                ),
              },
              {
                key: "payment",
                title: `${t("payment")}`,
              },
            ]}
          />
          {locale == "th" ? <ComponentTh /> : <ComponentEn />}
        </Col>
      </Row>
    </App>
  );
};

export default Home;
